// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"4f91254e","196":"c681a781","318":"c5f70afd","431":"bc810599","720":"02ce72f1"}[chunkId] + ".chunk.js";
};